import router from 'app/router'

export default {

    namespaced: true,

    state: {
        'arrivals.type': 'all',
        'universe.links': 'd'
    },

    getters: {

        active: function() {

            return {}

        },

        values: function(state) {

            return state

        },

        'arrivals.type': function(state) {

            return state['arrivals.type']

        },

        'universe.links': function(state) {

            return state['universe.links']

        }

    },

    mutations: {

        reset: function(state) {

            state['arrivals.type'] = 'all'
            state['universe.links'] = 'd'

        },

        'arrivals.type': function(state, value) {

            state['arrivals.type'] = value

        },

        'universe.links': function(state, value) {

            state['universe.links'] = value

        }

    },

    actions: {

        analyse: function(context, params) {

            return new Promise(function(resolve) {

                context.commit('reset')

                if (params !== undefined) {

                    if (params['arrivals.type']) context.state['arrivals.type'] = params['arrivals.type']
                    if (params['universe.links']) context.state['universe.links'] = params['universe.links']

                }

                resolve()

            })

        },

        route: function(context) {

            var urlParams = {}

            if (context.state['arrivals.type'] !== 'all') urlParams['arrivals.type'] = context.state['arrivals.type']
            if (context.state['universe.links'] !== 'd') urlParams['universe.links'] = context.state['universe.links']

            router.replace({ name: 'InsightsGames', query: urlParams }).catch(function() {})

        }

    }

}
